import React, { Component } from "react";
import { connect } from "react-redux";

import axios from "axios";
import { toast } from "react-toastify";

import "./style.css";

class NoAuthFileShare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notDownloaded: true,
      fileName: "",
      downloadError: false,
    };
  }

  getFileIdentifiers = () => {
    const { fileGuid, fileId, location } = this.props;

    if (fileGuid && fileGuid !== "" && fileId) {
      return { qFileGuid: fileGuid, qFileId: fileId };
    }

    const hashSource = (location && location.hash) || window.location.hash || "";
    if (!hashSource) return { qFileGuid: null, qFileId: null };

    const hashPayload = hashSource.startsWith("#") ? hashSource.slice(1) : hashSource;
    const [maybeFileId, maybeFileGuid] = hashPayload.split("+");

    return {
      qFileGuid: maybeFileGuid || null,
      qFileId: maybeFileId || null,
    };
  };

  componentDidMount() {
    const { qFileGuid, qFileId } = this.getFileIdentifiers();

    if (!qFileGuid || !qFileId) {
      return;
    }

    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/files/getDownloadInfo`,
        {
          fileGuid: qFileGuid,
          fileId: qFileId,
        },
        {
          headers: {
            ClientToken: localStorage.getItem("clientToken"),
          },
        },
      )
      .then((res) => {
        this.setState({ fileName: res.data.fileName });
      });
  }
  componentDidUpdate() {
    const { qFileGuid, qFileId } = this.getFileIdentifiers();
    if (qFileGuid && qFileId && this.state.notDownloaded) {
      axios
        .post(
          `${process.env.REACT_APP_BIGHORN_SERVER}/api/files/downloadFileShare`,
          {
            fileGuid: qFileGuid,
            fileId: qFileId,
          },
          {
            headers: {
              ClientToken: localStorage.getItem("clientToken"),
            },
            responseType: "arraybuffer",
          },
        )
        .then((res) => {
          console.log(res.headers);
          const fileName = decodeURIComponent(res.headers["content-disposition"].split("=")[1]);
          const contentType = res.headers["content-type"] || "application/octet-stream"; // get content-type from response headers or set default value
          console.log("CONTENT TYPE " + contentType);
          const blob = new Blob([res.data], { type: contentType }); // Create Blob from arraybuffer response
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;

          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          let message = "There was an error downloading this file: file not found";
          try {
            const errJson = JSON.parse(new TextDecoder().decode(err.response?.data));
            if (errJson?.message) message = `There was an error downloading this file: ${errJson.message}`;
          } catch (_) {}
          toast.error(message);
          this.setState({ downloadError: true });
        });
      this.setState({ notDownloaded: false });
    }
  }

  render() {
    if (this.props.error !== null || this.state.downloadError) {
      return (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
          <div>File Share Error!</div>
        </div>
      );
    } else {
      return (
        <div className="no-auth-file-share" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <div style={{ marginTop: "30px", fontSize: "30px" }}>Downloading File...</div>
          <div>{this.state.fileName}</div>
          <div style={{ marginTop: "40px", fontSize: "20px" }}>Download didn't start?</div>
          <div
            className="download-link"
            style={{}}
            onClick={() => {
              this.setState({ notDownloaded: true });
            }}>
            Click here to download
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  fileId: state.app.fileId,
  fileGuid: state.app.fileGuid,
  error: state.app.error,
  // reportSubLoading: state.rptSubscriptions.loading
});

const mapDispatchToProps = (dispatch) => ({
  // addTabToNav(tab) {
  //   dispatch(addTabToNav(tab));
  // },
  // getReportSubscriptions(loading, user) {
  //   dispatch(getReportSubscriptions(loading, null, user));
  // },
  // deleteReportSubscription(rptSubId, user) {
  //   dispatch(deleteReportSubscription(rptSubId, null, user));
  // },
  // selectAllSubscriptions(selectAll) {
  //   dispatch(selectAllSubscriptions(selectAll));
  // }
});

export default connect(mapStateToProps, mapDispatchToProps)(NoAuthFileShare);
